<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable max-width="600">
      <v-card>
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title
            class="black--text w-100 ta-c headline font-weight-bold"
            >บันทึกการปลูกต้นไม้</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-container
              grid-list-md
              pa-0
              class="modal_loading"
              v-if="loading_save"
            >
            </v-container>
            <v-container grid-list-md pa-0>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 md12>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    color="blue"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFormatted"
                        readonly
                        prepend-inner-icon="event"
                        label="วันที่ปลูก*"
                        solo
                        hide-details
                        v-on="on"
                        color="blue"
                        @blur="date = parseDate(dateFormatted)"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="th"
                      v-model="date"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center mb-2>
                <v-flex xs12 md12 mt-2>
                  <span style="font-size: 18px;" class="font-weight-bold"
                    >สถานที่ปลูก</span
                  >
                  <v-radio-group
                    v-model="placetoSeed"
                    row
                    hide-details
                    style="margin-top:-10px"
                    :rules="nameRules"
                  >
                    <v-radio
                      label="ระบุพิกัดแปลงปลูกต้นไม้"
                      value="latlong"
                      hide-details
                    ></v-radio>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          small
                          color="primary"
                          icon
                          :loading="loading"
                          @click="getGeolocation()"
                          style="margin-left: -10px;margin-right: 20px;"
                        >
                          <v-icon color="black">gps_fixed</v-icon>
                        </v-btn>
                      </template>
                      <span>ค้นหาตำแหน่งปัจจุบัน</span>
                    </v-tooltip>
                    <v-radio
                      label="ระบุที่อยู่แปลงปลูกต้นไม้่"
                      value="address"
                      hide-details
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <!-- address -->
              <div class="" v-if="placetoSeed === 'address'">
                <v-layout row wrap justify-center>
                  <v-flex xs12 md12>
                    <v-autocomplete
                      :items="listProvince"
                      label="จังหวัด*"
                      item-text="province_name"
                      item-value="province_id"
                      solo
                      hide-details
                      v-model="province_id"
                      @change="queryAmphoe()"
                      color="blue"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="listAmphoe"
                      label="อำเภอ*"
                      solo
                      item-text="amphoe_name"
                      item-value="amphoe_id"
                      hide-details
                      v-model="amphoe_id"
                      @change="queryTambon()"
                      color="blue"
                      :disabled="province_id === '' ? true : false"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="listTambon"
                      label="ตำบล*"
                      solo
                      hide-details
                      v-model="tambon_id"
                      item-text="tambon_name"
                      item-value="tambon_id"
                      color="blue"
                      :disabled="amphoe_id === '' ? true : false"
                      :rules="placetoSeed === 'address' ? nameRules : []"
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </div>
              <!-- latlong -->
              <div class="add_mt" v-if="placetoSeed === 'latlong'">
                <v-layout row wrap justify-center>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="ละติจูด*"
                      v-model="latitude"
                      solo
                      type="number"
                      hide-details
                      :disabled="loading ? true : false"
                      :rules="placetoSeed === 'latlong' ? nameRules : []"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="ลองจิจูด*"
                      v-model="longitude"
                      solo
                      type="number"
                      hide-details
                      :disabled="loading ? true : false"
                      :rules="placetoSeed === 'latlong' ? nameRules : []"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <v-layout row wrap justify-center mt-3>
                <v-flex md12 sm12>
                  <span style="font-size: 18px;" class="font-weight-bold"
                    >รายละเอียดต้นไม้</span
                  >
                  <span class="body-2">
                    (สามารถเพิ่มชนิดไม้ได้ครั้งละไม่เกิน 10 ชนิดต่อการบันทึก 1
                    ครั้ง)</span
                  >
                </v-flex>
                <!-- <pre> {{ plantInformation }}</pre> -->

                <v-layout
                  row
                  wrap
                  v-for="(i, index) in plantInformation"
                  :key="index"
                >
                  <v-flex md12>
                    <v-card class="box-card">
                      <v-container grid-list-xs pa-2>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <div style="display:flex;align-items:center;">
                              <span
                                class="ml-1 font-weight-bold"
                                style="font-size:16px"
                                >ชนิดที่ {{ index + 1 }}</span
                              >
                              <v-btn
                                @click="removeComponent(index)"
                                small
                                color="error"
                                icon
                                class="mt-0"
                                v-if="plantInformation.length !== 1"
                              >
                                <v-icon dark>remove</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                          <!-- <pre>{{ listPlant }}</pre> -->
                          <v-flex xs12 sm12 md6>
                            <v-autocomplete
                              :items="computedItems"
                              label="พิมพ์ชื่อต้นไม้*"
                              v-model="i.plant_id"
                              solo
                              item-text="plant_name"
                              item-value="plant_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :rules="nameRules"
                              required
                              return-object
                              :menu-props="menuProps"
                              @change="disabledItem()"
                            >
                              <template v-slot:no-data>
                                <v-list-tile @click="clickOther(index)">
                                  <v-list-tile-title>
                                    ไม้ยืนต้นอื่นๆ
                                  </v-list-tile-title>
                                </v-list-tile>
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              label="จำนวน*"
                              solo
                              hide-details
                              suffix="ต้น"
                              color="blue"
                              :mask="mask"
                              v-model="i.amount"
                              :rules="nameRules"
                              required
                              ref="amount"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md12 style="max-width:100%">
                            <div style="max-width:100%;" class="pointer">
                              <!-- <v-layout row wrap>
                                <v-flex xs12 md12 class="ta-c">
                                  <div
                                    outline
                                    :class="[
                                      i.check
                                        ? 'border-upload-warning'
                                        : 'border-upload',
                                    ]"
                                    block
                                    @click="pickFile(index)"
                                    style="height: 80px; white-space: unset !important; overflow-y: auto;"
                                    class="upload_tree"
                                  >
                                    <input
                                      ref="image_input_upload"
                                      type="file"
                                      multiple
                                      @change="onFileChange($event, index)"
                                      style="display: none"
                                      accept="image/*"
                                    />
                                    <div v-if="i.attachment.length == []">
                                      <v-icon class="mr-1">camera_alt</v-icon
                                      ><span class="title"
                                        >อัพโหลดรูปต้นไม้*</span
                                      >
                                    </div>
                                    <div v-else style="max-height:60px;">
                                      <span
                                        v-for="(att, index2) in i.attachment"
                                        :key="index2"
                                      >
                                        <v-chip
                                          close
                                          @input="remove(att.name, index)"
                                        >
                                          <v-flex>{{ att.name }}</v-flex>
                                        </v-chip>
                                      </span>
                                    </div>
                                  </div>
                                </v-flex>
                              </v-layout> -->
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between mt-2 ml-2>
                  <v-flex md12 style="text-align: end;">
                    <v-btn
                      @click="addComponent()"
                      round
                      color="primary"
                      class="mt-0"
                      :disabled="disabled_add ? true : false"
                      style="font-size:16px;"
                    >
                      <v-icon dark>add</v-icon>เพิ่มชนิดไม้
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>

              <v-layout row wrap justify-center mt-2 pl-0>
                <v-flex xs12 md12 class="mt-0">
                  <span style="font-size:18px" class="font-weight-bold"
                    >ได้รับต้นไม้จาก*</span
                  >
                </v-flex>

                <v-flex xs12 md12>
                  <div class="mt-0">
                    <v-radio-group
                      class="mt-1"
                      hide-details
                      v-model="treeFromDepartment"
                      v-for="(i, index) in listDepartment"
                      :key="index"
                      :rules="nameRules"
                    >
                      <div :class="i.department_id === 1 ? 'for-rfd' : 'for-other'">
                        <v-radio
                          :label="i.department_name"
                          :value="i.department_id"
                          hide-details
                        ></v-radio>
                        <v-layout
                          row
                          wrap
                          v-show="i.department_id === 1"
                          v-if="treeFromDepartment === 1"
                          ><v-flex md12
                            >(หากทราบ โปรดระบุศูนย์/สถานี
                            ที่ได้รับต้นไม้)</v-flex
                          >
                          <!-- <v-flex md6>
                            <v-autocomplete
                              :items="listSubDepartment"
                              label="พิมพ์ชื่อหน่วยงานย่อย"
                              v-model="subDepartment"
                              solo
                              item-text="department_name"
                              item-value="department_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :menu-props="menuProps"
                              clearable
                              @click:clear="onClearClickedSub"
                            ></v-autocomplete>
                          </v-flex> -->
                          <!-- {{ subSubDepartment }} -->
                          <v-flex xs12 md12>
                            <v-autocomplete
                              v-show="i.department_id === 1"
                              v-if="treeFromDepartment === 1"
                              :items="listSubSubDepartment"
                              label="พิมพ์ชื่อศูนย์/สถานี"
                              v-model="subSubDepartment"
                              solo
                              item-text="department_name"
                              item-value="department_id"
                              hide-details
                              hide-selected
                              persistent-hint
                              color="blue"
                              :menu-props="menuProps"
                              clearable
                              @click:clear="onClearClickedSubSub"
                              return-object
                              :rules="treeFromDepartment === 1 ? nameRules : ''"
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-text-field
                            label="โปรดระบุ"
                            v-model="other"
                            solo
                            hide-details
                            v-if="i.department_id === 4"
                            :disabled="treeFromDepartment === 4 ? false : true"
                            class="other"
                            required
                            :rules="treeFromDepartment === 4 ? nameRules : []"
                          ></v-text-field>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row wrap mt-4>
            <span style="font-size: 18px;" class="font-weight-bold"
              >รายละเอียดเพิ่มเติม</span
            >
            <v-flex xs12 md12>
              <v-text-field
                label="บันทึก"
                v-model="note"
                solo
                hide-details
                :disabled="loading ? true : false"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="ta-c jc-c">
          <!-- <v-btn color="green darken-1" flat @click="test()">test</v-btn> -->
          <v-btn color="green darken-1" flat @click="dialog = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            color="primary"
            round
            @click="submit()"
            :disabled="loading ? true : false"
            :loading="loading_save"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
var _ = require("lodash");
import { Decode } from "@/services";
import { handleAjaxError } from "@/utils/common";
export default {
  props: {
    cardId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      disabled: false,
      disabled_add: false,
      dialog: false,
      dateFormatted: "",
      date: "",
      menu: false,
      imageName: "",
      listDepartment: [],
      listSubDepartment: [],
      listSubSubDepartment: [],
      treeFromDepartment: "",
      subDepartment: null,
      subSubDepartment: null,
      placetoSeed: "latlong",
      hasImage: false,
      image: null,
      mask: "#####",
      province_id: "",
      amphoe_id: "",
      tambon_id: "",
      attachment: [],
      listPlant: [],
      listProvince: [],
      listAmphoe: [],
      listTambon: [],
      latitude: "",
      longitude: "",
      plant_id: "",
      other: "",
      loading: false,
      amount: "",
      card_id: "",
      note: "",
      disabledItems: [],
      loading_save: false,
      nameRules: [(v) => !!v || "Name is required"],
      listLatLng: "",
      check: "",
      menuProps: {
        closeOnClick: false,
        closeOnContentClick: true,
      },
      plantInformation: [
        {
          plant_id: "",
          amount: "",
          attachment: [],
          check: false,
        },
      ],
    };
  },
  created() {
    if (this.cardId) {
      this.card_id = this.cardId;
    } else if (this.$cookies && this.$cookies.get("token")) {
      try {
        const result = Decode.decode(this.$cookies.get("token"));
        this.card_id = JSON.parse(result).card_id;
      } catch (e) {
        this.card_id = "";
      }
    }
    this.queryDepartment();
    this.queryPlant();
    this.queryProvince();
    this.querySubSubDepartment();
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    placetoSeed() {
      if (this.placetoSeed === "address") {
        this.latitude = "";
        this.longitude = "";
        this.loading = false;
      } else {
        this.province_id = "";
        this.amphoe_id = "";
        this.tambon_id = "";
      }
    },
    plantInformation() {
      if (this.plantInformation.length === 10) {
        this.disabled_add = true;
      } else {
        this.disabled_add = false;
      }
    },
    treeFromDepartment() {
      // this.querySubDepartment(this.treeFromDepartment);
      // this.subDepartment = null;
      this.subSubDepartment = null;
    },
    // subDepartment() {
    //   if (this.subDepartment) {
    //     this.querySubSubDepartment(this.subDepartment);
    //   } else {
    //     this.subSubDepartment = null;
    //     this.subDepartment = null;
    //   }
    // },
  },
  computed: {
    computedItems() {
      return this.listPlant.map((item) => {
        return {
          plant_id: item.plant_id,
          plant_name: item.plant_name,
          disabled: this.disabledItems.includes(item.plant_id),
        };
      });
    },
  },
  methods: {
    onClearClickedSub() {
      this.subDepartment = null;
      this.subSubDepartment = null;
    },
    onClearClickedSubSub() {
      this.subSubDepartment = null;
    },
    disabledItem() {
      this.disabledItems = [];
      _.forEach(this.plantInformation, (p) => {
        if (p.plant_id.plant_id !== 126) {
          this.disabledItems.push(p.plant_id.plant_id);
        }
      });
    },
    clickOther(index) {
      this.plantInformation[index].plant_id = {
        plant_id: 218,
        plant_name: "ไม้ยื่นต้นอื่นๆ",
        disabled: false,
      };
    },
    getGeolocation() {
      this.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.getPositionErrorHandle,
          {
            timeout: 10000,
            enableHighAccuracy: true,
            maximumAge: 0,
          }
        );
      }
    },
    showPosition(position) {
      // console.log(position);
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.loading = false;
    },
    getPositionErrorHandle(positionError) {
      switch (positionError.code) {
        case 1: //PERMISSION_DENIED
          this.$swal(
            "กรุณาเปิดสิทธิ์การเข้าถึงที่อยู่ของท่านบนบราวเซอร์",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        case 2: //POSITION_UNAVAILABLE
          this.$swal(
            "ระบบไม่สามารถหาตำแหน่งได้",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        case 3: //TIMEOUT
          this.$swal(
            "ระบบใช้เวลาค้นหาเกินกำหนด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          this.loading = false;
          break;
        default:
      }
    },

    queryDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryDepartment")
        .then((response) => {
          // console.log(response);
          this.listDepartment = response.data;
        });
    },
    // querySubDepartment(sub_id) {
    //   this.axios
    //     .post(process.env.VUE_APP_IPFLASK + "/querySubDepartment", {
    //       sub_department_id: sub_id,
    //     })
    //     .then((response) => {
    //       // console.log(response.data);
    //       if (response.data.length !== 0) {
    //         this.listSubDepartment = response.data;
    //         // console.log(this.listSubDepartment);
    //       }
    //     });
    // },
    querySubSubDepartment() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/querySubSubDepartment")
        .then((response) => {
          // console.log(response.data);
          if (response.data.length !== 0) {
            this.listSubSubDepartment = response.data;
            // console.log(this.listSubSubDepartment);
          }
        });
    },
    queryPlant() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryPlant")
        .then((response) => {
          this.listPlant = response.data;
        });
    },
    queryProvince() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryProvince")
        .then((response) => {
          this.listProvince = response.data;
        });
    },
    queryAmphoe() {
      this.tambon_id = "";
      this.amphoe_id = "";
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAmphoe", {
          province_id: this.province_id.province_id,
        })
        .then((response) => {
          this.listAmphoe = response.data;
        });
    },
    queryTambon() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryTambon", {
          amphoe_id: this.amphoe_id.amphoe_id,
        })
        .then((response) => {
          this.listTambon = response.data;
        });
    },
    openDialog() {
      this.dialog = true;
      this.loading_save = false;
      this.$refs.form.resetValidation();
      this.date = "";
      this.plant_id = "";
      this.amount = "";
      this.province_id = "";
      this.amphoe_id = "";
      this.tambon_id = "";
      this.latitude = "";
      this.longitude = "";
      this.treeFromDepartment = "";
      this.subDepartment = "";
      this.subSubDepartment = "";
      // this.attachment = []
      this.other = "";
      this.note = "";
      this.placetoSeed = "latlong";
      this.check = false;
      this.loading = false;
      this.plantInformation = [
        {
          plant_id: "",
          amount: "",
          attachment: [],
          check: false,
        },
      ];
      this.disabledItems = [];
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}/${month}/${year_thai}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      var year_2 = parseInt(year) - 543;
      return `${year_2}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // onFileChange(event, index) {
    //   let e = event;
    //   let files = e.target.files;
    //   if (!files.length) return;

    //   // console.log(files)
    //   let new_files = _.filter(files, (file) => {
    //     var duplicate = false;
    //     _.each(this.plantInformation[index].attachment, (plant) => {
    //       if (plant.name == file.name) {
    //         duplicate = true;
    //       }
    //     });
    //     if (duplicate) {
    //       return false;
    //     }
    //     return true;
    //   });
    //   // console.log(new_files)
    //   this.createImage(new_files, index);
    //   this.$refs["image_input_upload"][index].value = "";
    // },
    // pickFile(index) {
    //   this.$refs["image_input_upload"][index].click();
    // },
    // createImage(files, index) {
    //   // console.log(files)
    //   for (var i = 0; i < files.length; i++) {
    //     this.plantInformation[index].attachment.push({
    //       file: files[i],
    //       no: this.plantInformation[index].attachment.length,
    //       type: files[i].type,
    //       name: files[i].name,
    //     });
    //   }
    //   this.plantInformation[index].check = false;
    // },
    remove(name, index) {
      this.plantInformation[index].attachment.splice(
        _.findIndex(this.plantInformation[index].attachment, { name }),
        1
      );
    },
    addComponent() {
      this.plantInformation.push({
        plant_id: "",
        amount: "",
        attachment: [],
        check: "",
      });
      this.check = false;
    },
    removeComponent(index) {
      this.plantInformation.splice(index, 1);
    },
    submit() {
      this.loading_save = true;
      var isCheckPic = true;
      // _.each(this.plantInformation, (plant) => {
      //   if (plant.attachment.length === 0) {
      //     plant.check = true;
      //     this.$swal("กรุณาอัพโหลดภาพที่ถ่ายกับต้นไม้ของท่าน", "", "error");
      //     isCheckPic = false;
      //     this.loading_save = false;
      //   }
      // });
      if (this.$refs.form.validate() && isCheckPic) {
        if (this.placetoSeed === "address") {
          this.latitude = this.tambon_id.latitude;
          this.longitude = this.tambon_id.longitude;
        }
        var formData = new FormData();
        formData.append("card_id", this.card_id);
        formData.append("date", this.date);
        formData.append("province_id", this.province_id.province_id);
        formData.append("amphoe_id", this.amphoe_id.amphoe_id);
        formData.append("tambon_id", this.tambon_id.tambon_id);
        formData.append("latitude", this.latitude);
        formData.append("longitude", this.longitude);
        formData.append("other", this.other);
        formData.append("note", this.note);
        formData.append("treeFromDepartment", this.treeFromDepartment);
        if (this.treeFromDepartment == 1) {
          formData.append(
            "subDepartment",
            this.subSubDepartment.parent_department_id
          );
          formData.append(
            "subSubDepartment",
            this.subSubDepartment.department_id
          );
        } else {
          formData.append("subDepartment", this.subSubDepartment);
          formData.append("subSubDepartment", this.subSubDepartment);
        }

        this.plantInformation.forEach((attach, i) => {
          formData.append(
            "plantInformation",
            JSON.stringify(this.plantInformation)
          );
          attach.attachment.forEach((a) => {
            formData.append("plantInformationImage[" + i + "]", a.file);
          });
        });

        // for (var pair of formData.entries()) {
        //   console.log(pair[0]+ ', ' + pair[1]);
        // }
        // console.log(this.plantInformation);
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/insertPlant", formData)
          .then((response) => {
            // console.log(response.data);
            if (response.data === "Insert Success") {
              this.dialog = false;
              this.$swal("บันทึกการปลูกต้นไม้เรียบร้อย", "", "success");
              this.date = "";
              this.plant_id = "";
              this.amount = "";
              this.province_id = "";
              this.amphoe_id = "";
              this.tambon_id = "";
              this.latitude = "";
              this.longitude = "";
              this.treeFromDepartment = "";
              this.subDepartment = "";
              this.subSubDepartment = "";
              this.plantInformation = [
                {
                  plant_id: "",
                  amount: "",
                  attachment: [],
                  check: false,
                },
              ];
              this.disabledItems = [];
              this.placetoSeed = "latlong";
              this.other = "";
              this.note = "";
              this.loading_save = false;
              this.$emit("fetch", true);
            } else if (response.data === "Cannot find lat lng") {
              this.$swal(
                "กรุณาตรวจสอบพิกัดแปลงปลูกต้นไม้",
                "ระบบรองรับบันทึกข้อมูลการปลูกต้นไม้ภายในประเทศไทยเท่านั้น",
                "error"
              );
              this.loading_save = false;
            }
          })
          .catch((error) => handleAjaxError(error, this));
      } else {
        this.$swal("กรุณากรอกข้อมูลให้ครบถ้วน", "", "error");
        // this.check = true
        this.loading_save = false;
      }
    },
  },
};
</script>

<style scoped>
.border-upload {
  border: 2px solid #c4c4c4;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 5px;
}
.border-upload-warning {
  border: 2px solid red;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

.upload_tree .v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent !important;
}

.modal_loading {
  position: absolute;
  background: #4e4e4e70;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}

.line-short {
  border: 0.5px solid gray;
  width: 500px;
  margin-top: -8px;
}

@media only screen and (min-width: 768px) {
  .add_mt {
    margin-top: -15px;
  }
}

.box-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
}

.for-rfd {
  display: flex !important;
  flex-flow: column !important;
}

.for-other {
  display: flex !important;
}
</style>
